import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import {
  sync
} from "vuex-router-sync";
import VueElementLoading from "vue-element-loading";

import es from "vee-validate/dist/locale/es";
import VeeValidate, {
  Validator
} from 'vee-validate';


Vue.use(VeeValidate);
Validator.localize("es", es);

const moment = require("moment");
require("moment/locale/es");

Vue.use(require("vue-moment"), {
  moment
});
Vue.component("VueElementLoading", VueElementLoading);

Vue.config.productionTip = false;
const unsync = sync(store, router);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");